import { api } from './client';

export interface HappyPlaceDrawing {
  id: string;
  userId: number;
  name: string;
  imageUrl: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDrawingRequest {
  name: string;
  imageData: string;
}

export const happyPlaceApi = {
  createDrawing: async (data: CreateDrawingRequest): Promise<HappyPlaceDrawing> => {
    return api.post('/happy-place/drawings', data);
  },

  getDrawings: async (): Promise<HappyPlaceDrawing[]> => {
    return api.get('/happy-place/drawings');
  },

  deleteDrawing: async (id: string): Promise<{ message: string }> => {
    return api.delete(`/happy-place/drawings/${id}`);
  },

  downloadDrawing: async (id: string): Promise<Blob> => {
    const blob = await api.getBlob(`/happy-place/drawings/${id}/download`);
    return new Blob([blob], { type: 'image/png' });
  },
};
